import React from "react";

export default function ActivityIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "20px",
        height: "20px",
        marginLeft: "0.3rem",
      }}
      fill="#fcfcfc"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <polyline
        points="24 128 56 128 96 40 160 208 200 128 232 128"
        fill="none"
        stroke="#fcfcfc"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
    </svg>
  );
}
